import type {
    ActivityChatMessage,
    ChatActivityMessageParticipants,
} from '../types';

export const appendGroupedParticipants = (
    previousMessage: ActivityChatMessage,
    newMessage: ActivityChatMessage,
): ChatActivityMessageParticipants[] | undefined => {
    if (previousMessage.groupedParticipants?.length) {
        return [
            ...previousMessage.groupedParticipants,
            {
                isMe: newMessage.isMe,
                displayName: newMessage.displayName,
            },
        ];
    }

    return [
        {
            displayName: previousMessage.displayName,
            isMe: previousMessage.isMe,
        },
        {
            displayName: newMessage.displayName,
            isMe: newMessage.isMe,
        },
    ];
};

export const buildGroupedActivityMessage = (
    previousMessage: ActivityChatMessage,
    newMessage: ActivityChatMessage,
): ActivityChatMessage => ({
    ...newMessage,
    userId: undefined,
    displayName: '',
    groupedParticipants: appendGroupedParticipants(previousMessage, newMessage),
});
